import * as React from 'react'
import { ActionIcon } from '@mantine/core'

// 救灾物资储备库
const SvgComponent = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 26"
    className="design-iconfont"
    width={width}
    height={height}
  >
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="98.993%"
        id="8ing2w58f__01tigccilb"
      >
        <stop stopColor="#4AB6F5" offset="0%" />
        <stop stopColor="#227BF9" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="8ing2w58f__rp4uzuzmra"
      >
        <stop stopColor="#7DCFFF" offset="0%" />
        <stop stopColor="#60A2FE" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M10.759 1a9.698 9.698 0 0 1 6.898 2.874 9.82 9.82 0 0 1 2.86 6.946c0 2.385-1.506 5.3-3.329 7.873C14.858 21.98 11.923 25 10.758 25c-1.164 0-4.098-3.019-6.43-6.307C2.507 16.12 1 13.205 1 10.82a9.82 9.82 0 0 1 2.86-6.946A9.698 9.698 0 0 1 10.76 1Z"
        stroke="url(#8ing2w58f__rp4uzuzmra)"
        strokeWidth={2}
        fill="url(#8ing2w58f__01tigccilb)"
      />
      <path
        d="m15.89 10.634-5.25-5.423a.129.129 0 0 0-.185 0l-5.248 5.423c-.081.085-.023.228.093.228h.826v4.95c0 .082.065.149.146.15h8.525a.148.148 0 0 0 .146-.15v-4.95h.854c.116 0 .174-.143.093-.228ZM8.229 15.31a.12.12 0 0 1-.118.12h-.88a.12.12 0 0 1-.118-.12v-.9a.12.12 0 0 1 .118-.12h.88a.12.12 0 0 1 .118.12v.9Zm0-1.56a.12.12 0 0 1-.118.12h-.88a.12.12 0 0 1-.118-.12v-.9a.12.12 0 0 1 .118-.121h.88a.12.12 0 0 1 .118.12v.9Zm0-1.564a.12.12 0 0 1-.118.12h-.88a.12.12 0 0 1-.118-.12v-.9a.12.12 0 0 1 .118-.121h.88a.12.12 0 0 1 .118.12v.901Zm1.503 3.124a.12.12 0 0 1-.117.12h-.88a.12.12 0 0 1-.119-.12v-.9a.12.12 0 0 1 .118-.12h.88a.12.12 0 0 1 .118.12v.9Zm0-1.56a.12.12 0 0 1-.117.12h-.88a.12.12 0 0 1-.119-.12v-.9a.12.12 0 0 1 .118-.121h.88a.12.12 0 0 1 .118.12v.9Zm1.53 1.56a.12.12 0 0 1-.118.12h-.88a.12.12 0 0 1-.118-.12v-.9a.12.12 0 0 1 .118-.121h.88a.12.12 0 0 1 .118.12v.9Z"
        fill="#E2F2FF"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

const JzwzcbkIcon = (props) => {
  const {
    fill = '#0152D9',
    variant = 'transparent',
    size = 20,
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <SvgComponent width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default JzwzcbkIcon
